import { render } from "./SkeletonPayment.vue?vue&type=template&id=4f51e579"
import script from "./SkeletonPayment.vue?vue&type=script&lang=js"
export * from "./SkeletonPayment.vue?vue&type=script&lang=js"

import exportComponent from "/opt/anthos/FBL_OTWS/OTWS_src5/otws-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__